import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { faCheck, faPlusCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { TenantWords } from '../../../models/tenantWords';
import { TenantWordService } from '../../../services/TenantWord.service';
import { WordListTableDataSource } from './word-list-table-datasource';

@Component({
  selector: 'word-list-table',
  templateUrl: './word-list-table.component.html',
  styleUrls: ['./word-list-table.component.css']
})



export class WordListTableComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: WordListTableDataSource;
  public faPlusCircle = faPlusCircle;

  public editWord: TenantWords = {};
  public wordId: number;
  public wordLoading = false;
  public submitting: any;
  public editActive = false;
  
  public faTimes = faTimes;
  public faCheck = faCheck;
  
  private destroyRef = inject(DestroyRef);
  constructor(
    private wordService: TenantWordService,
    private errorService: ErrorService
  ){}


  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['originalWord', 'replacementWord', 'isActive', 'edit'];

  ngOnInit() {
    this.dataSource = new WordListTableDataSource(this.paginator, this.sort);

    this.dataSource.data = JSON.parse(localStorage.getItem('tenantWordDictionary'));
    this.paginator._changePageSize(this.paginator.pageSize);
    
  }

  editClicked(id : number) {
    this.editWord = {...this.dataSource.data.filter(u => u.id === id)[0]};
    this.editActive = true;
  }

  saveWordClicked() {
    if(this.editWord.isActive === null || this.editWord.isActive === undefined){ this.editWord.isActive = false; }
    if(this.editWord.id !== null && this.editWord.id !== undefined){
        let index =  this.dataSource.data.indexOf(this.dataSource.data.filter(w => w.id === this.editWord.id)[0]);
        this.wordService.putTenantWords(this.editWord).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.dataSource.data[index] = this.editWord;
        localStorage.setItem('tenantWordDictionary', JSON.stringify(this.dataSource.data));
        this.paginator._changePageSize(this.paginator.pageSize)
        this.editWord = {};
      }, error:err => {this.errorService.handleError(err)}});
    }
    else{
        this.wordService.postTenantWords(this.editWord).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
          this.editWord.id = x.id;
          this.dataSource.data.push(this.editWord);
          localStorage.setItem('tenantWordDictionary', JSON.stringify(this.dataSource.data));
          this.paginator._changePageSize(this.paginator.pageSize)
          this.editWord = {};
      }, error:err => {this.errorService.handleError(err)}});
    }
    this.editActive = false;
  }

  cancelClicked() {
    this.editActive = false;
    this.editWord = {};
  }

  deleteWordClicked(){
    if(this.editWord.id !== null && this.editWord.id !== undefined){
      this.wordService.deleteTenantWords(this.editWord.id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
        this.dataSource.data.splice(this.dataSource.data.indexOf(this.editWord), 1);
        this.paginator._changePageSize(this.paginator.pageSize)
        localStorage.setItem('tenantWordDictionary', JSON.stringify(this.dataSource.data));
        this.editWord = {};
      }, error:err => {this.errorService.handleError(err)}});
    }
    else{
      alert("No Dictionary Selected!!");
    }
    this.editActive = false;
  }

  addWordClicked(){
    this.editWord = {};
    this.editActive = true;
  }
}
